import { render, staticRenderFns } from "./PaginaVerificaBilancioCoccia.vue?vue&type=template&id=ebddc6b2"
import script from "./PaginaVerificaBilancioCoccia.vue?vue&type=script&lang=js"
export * from "./PaginaVerificaBilancioCoccia.vue?vue&type=script&lang=js"
import style0 from "./PaginaVerificaBilancioCoccia.vue?vue&type=style&index=0&id=ebddc6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports